import { render, staticRenderFns } from "./attachCrew.vue?vue&type=template&id=53f99b17&scoped=true&"
import script from "./attachCrew.vue?vue&type=script&lang=ts&"
export * from "./attachCrew.vue?vue&type=script&lang=ts&"
import style0 from "./attachCrew.vue?vue&type=style&index=0&id=53f99b17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f99b17",
  null
  
)

export default component.exports